import "./styles.css";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import header2_1 from "../../assets/header2_1.png";
import header2_2 from "../../assets/header2_2.png";
import header2_3 from "../../assets/header2_3.png";
import header2_4 from "../../assets/header2_4.png";
import header2_5 from "../../assets/header2_5.png";
import header2_6 from "../../assets/header2_6.png";
import header2_7 from "../../assets/header2_7.png";
import header2_8 from "../../assets/header2_8.png";
import header2_9 from "../../assets/header2_9.png";
import header2_1Mobile from "../../assets/mobile/header2_1.png";
import header2_2Mobile from "../../assets/mobile/header2_2.png";
import header2_3Mobile from "../../assets/mobile/header2_3.png";
import header2_4Mobile from "../../assets/mobile/header2_4.png";
import header2_5Mobile from "../../assets/mobile/header2_5.png";
import header2_6Mobile from "../../assets/mobile/header2_6.png";
import header2_7Mobile from "../../assets/mobile/header2_7.png";
import header2_8Mobile from "../../assets/mobile/header2_8.png";
import header2_9Mobile from "../../assets/mobile/header2_9.png";
import whats from "../../assets/whats.png";

import CtaWpp from "../../components/CTAWpp";

const data = [
  {
    id: 1,
    image: header2_1,
    mobile: header2_1Mobile,
  },
  {
    id: 2,
    image: header2_2,
    mobile: header2_2Mobile,
  },
  {
    id: 3,
    image: header2_3,
    mobile: header2_3Mobile,
  },
  {
    id: 4,
    image: header2_4,
    mobile: header2_4Mobile,
  },
  {
    id: 5,
    image: header2_5,
    mobile: header2_5Mobile,
  },
  {
    id: 6,
    image: header2_6,
    mobile: header2_6Mobile,
  },
  {
    id: 7,
    image: header2_7,
    mobile: header2_7Mobile,
  },
  {
    id: 8,
    image: header2_8,
    mobile: header2_8Mobile,
  },
  {
    id: 9,
    image: header2_9,
    mobile: header2_9Mobile,
  },
];

const Header = () => {
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  return (
    <header id="header">
      <section className="header1">
        <article className="container">
          <h1 className="title">
            Advocacia <span>Trabalhista</span> Especializada
          </h1>

          <p className="text">
            Atuação estratégica para resolver conflitos trabalhistas com
            eficiência.
          </p>

          <CtaWpp />
        </article>
      </section>

      <a
        href="http://wa.me/+5511973350633?text=Olá,%20Gostaria%20de%20falar%20com%20o%20advogado"
        target="_blank"
        rel="noreferrer"
        id="whats"
      >
        <figure>
          <img src={whats} alt="Ícone do Whatsapp" />
        </figure>
      </a>

      <section className="header2">
        <article className="container vertical">
          <h2 className="title">
            Questões trabalhistas com as quais <br />
            <span>podemos lhe ajudar</span>
          </h2>

          <div className="gallery">
            {data.map(({ id, image, mobile }) => {
              return (
                <figure key={id}>
                  <img
                    src={isMobile ? mobile : image}
                    alt={`Exemplo ${id} de Foto`}
                  />
                </figure>
              );
            })}
          </div>

          <CtaWpp />
        </article>
      </section>
    </header>
  );
};

export default Header;
